import { render, staticRenderFns } from "./friendDetail.vue?vue&type=template&id=fa983c5e&scoped=true&"
import script from "./friendDetail.vue?vue&type=script&lang=js&"
export * from "./friendDetail.vue?vue&type=script&lang=js&"
import style0 from "./friendDetail.vue?vue&type=style&index=0&id=fa983c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa983c5e",
  null
  
)

export default component.exports